import { useStore } from 'effector-react'
import { Form } from '~/entities/common/Organizations/CarLicensee/ui/Form'
import { formSubmitted, createFx } from './model'

export const AddCarLicensee = () => {
  const isCreating = useStore(createFx.pending)

  return <Form isSubmitting={isCreating} isCreating onSuccess={formSubmitted} />
}
